import React from "react";
import md3 from "../styles/middle3.module.css";

const Middle3 = () => {
  return (
    <div>
      <div className={md3.body}>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Middle5.png?alt=media&token=aa6a843e-0db6-463b-ac21-117bb83d10ae"
          alt="md3image"
        />

        <div className={md3.mcntn}>
          <h3>Niffty major features includes the following but not limited:</h3>
          <div className={md3.cont}>
            <div className={md3.icon}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016665.svg?alt=media&token=0066a4f8-b782-4cc1-aacf-78fd307dca16"
                alt="btc"
                className={md3.btc}
              />
            </div>
            <div className={md3.innerc}>
              <p>
                A wonderful serenity has taken possession of my entire soul,
                like these sweet mornings of spring which I enjoy with my whole
                heart. I am alone.
              </p>
            </div>
          </div>
          <div className={md3.cont}>
            <div className={md3.icon}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016665.svg?alt=media&token=0066a4f8-b782-4cc1-aacf-78fd307dca16"
                alt="btc"
                className={md3.btc}
              />
            </div>
            <div className={md3.innerc}>
              <p>
                A wonderful serenity has taken possession of my entire soul,
                like these sweet mornings of spring which I enjoy with my whole
                heart. I am alone.
              </p>
            </div>
          </div>
          <div className={md3.cont}>
            <div className={md3.icon}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016665.svg?alt=media&token=0066a4f8-b782-4cc1-aacf-78fd307dca16"
                alt="btc"
                className={md3.btc}
              />
            </div>
            <div className={md3.innerc}>
              <p>
                A wonderful serenity has taken possession of my entire soul,
                like these sweet mornings of spring which I enjoy with my whole
                heart. I am alone.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle3;
